// Where a push alert's link should take someone who clicks its in-app toast
// (punch list line 34, 2026-09-25). Pushes carry data.url as a hash path on
// the CRM itself, e.g. "/#/dashboard/texting?c=lead%3AL1". Returns the route
// after the "#" ("/dashboard/texting?c=lead%3AL1"), or "" for anything that is
// not a plain link into the dashboard, so a toast can never send someone off
// the site or anywhere odd.
const ROUTE_RE = /^\/dashboard(\/[A-Za-z0-9_-]+)*\/?(\?[A-Za-z0-9%=&._~+-]*)?$/;

export function appRouteFromAlertUrl(url) {
  const s = String(url || "").trim();
  const m = /^\/?#(\/.*)$/.exec(s);
  if (!m) return "";
  const route = m[1];
  return ROUTE_RE.test(route) ? route : "";
}
